import React, { useEffect, useState, useRef } from 'react';




/*
const loadMollieScript = () => {
  const script = document.createElement('script');
  script.src = 'https://js.mollie.com/v1/mollie.js';
  script.async = true;
  document.body.appendChild(script);
};
*/

const CreditCardForm = ({store}) => {

    const [isLoading, setIsLoading] = useState(true);
    let mollieInstance = store.getState().selectedorderdata?.paymentmollieinstance || null;
    const cardHolder = useRef(null);
    const cardNumber = useRef(null);
    const expiryDate = useRef(null);
    const verificationCode = useRef(null);




  /*
  const handleSubmit = async (e) => {

    e.preventDefault();
    console.log("HandleSubmit");

    const form = document.getElementById('ips-final-checkout-form');
    const { token, error } = await mollie.createToken(); 
    console.log("HandleSubmit token made");

    if (error) {
      console.error(error);
      return;
    }

    const tokenInput = document.createElement('input');
    tokenInput.setAttribute('type', 'hidden');
    tokenInput.setAttribute('name', 'cardToken');
    tokenInput.setAttribute('value', token);

    form.appendChild(tokenInput);
    form.submit();
  };
  */





  useEffect(() => {
    //loadMollieScript();



       // Funktion zum Unmounten der Mollie-Komponenten
       const unmountMollieComponents = () => {
        if (window.Mollie) {
            console.log("************** UNMOUNT **************");
            // Hier werden die Mollie-Komponenten entfernt
            // Verwende hier die Referenzen auf die Mollie-Komponenten, die du im Mounting-Stadium erstellt hast
       
       /*     cardHolder.current.unmount();
            cardNumber.current.unmount();
            expiryDate.current.unmount();
            verificationCode.current.unmount();
            */
        }
    };



    const mollieScriptLoaded = () => {
      if (window.Mollie) {
        //const mollieInstance = window.Mollie('pfl_3RkSN1zuPE', { locale: 'de_DE', testmode: true }); // Zuweisung von mollie hier
        console.log("THE MOLLIE 222: ",mollieInstance);
        //store.dispatch(setpaymentApi("Test"));
        
       

        const options = {
          styles: {
            base: {
              backgroundColor: 'transparent',
              color: '#000',
              fontSize: '16px',
              '::placeholder': {
                color: 'rgba(68, 68, 68, 0.5)',
              },
            },
            valid: {
              color: '#090',
            },
            invalid: {
              color: '#f00',
            },
          },
        };



        console.log("************** MOUNT **************");
        cardHolder.current = mollieInstance.createComponent('cardHolder', options);
        cardHolder.current.mount('#card-holder');

        cardNumber.current = mollieInstance.createComponent('cardNumber', options);
        cardNumber.current.mount('#card-number');

        expiryDate.current = mollieInstance.createComponent('expiryDate', options);
        expiryDate.current.mount('#expiry-date');

        verificationCode.current = mollieInstance.createComponent('verificationCode', options);
        verificationCode.current.mount('#verification-code');





        cardHolder.current.addEventListener('change', event => {
          const errorElement = document.getElementById('card-holder-error');
          errorElement.textContent = event.error && event.touched ? event.error : '';
      });

      cardNumber.current.addEventListener('change', event => {
          const errorElement = document.getElementById('card-number-error');
          errorElement.textContent = event.error && event.touched ? event.error : '';
      });

      expiryDate.current.addEventListener('change', event => {
          const errorElement = document.getElementById('expiry-date-error');
          errorElement.textContent = event.error && event.touched ? event.error : '';
      });

      verificationCode.current.addEventListener('change', event => {
          const errorElement = document.getElementById('verification-code-error');
          errorElement.textContent = event.error && event.touched ? event.error : '';
      });

        setIsLoading(false);
        console.log("************** <>>< 1 <<<> **************");
           // Cleanup-Funktion, um Mollie-Komponenten beim Entladen der CreditCardForm-Komponente zu entfernen
       /*    return () => {
            console.log("************** UNMOUNT **************");
            cardHolder.unmount();
            cardNumber.unmount();
            expiryDate.unmount();
            verificationCode.unmount();
          };
          */
        

      }
    };

    
    if (document.readyState === 'complete') {
      console.log("mollie load 1");
      if (mollieInstance !== null && mollieInstance !== undefined) {
      mollieScriptLoaded();
      }
    } else {
      console.log("mollie load 2");
      window.addEventListener('load', () => {
        if (mollieInstance !== null && mollieInstance !== undefined) {
          mollieScriptLoaded();
        }
      });
      return () => window.removeEventListener('load', mollieScriptLoaded);
    }
// Cleanup-Funktion
if (mollieInstance) {
return unmountMollieComponents;
}

  }, [mollieInstance]);





  if (!mollieInstance) {
    return <div>Loading...</div>;
  }
  
  return (
   
<div id="ips-card-payment-form" className="wrapper mt-3">
{console.log("Render Page")} {/* Console-Protokoll hier einfügen */}
  <form method="post" className="form" id="mcForm" /* onSubmit={handleSubmit} */>
    <div className="form-fields">
      <div className="row mb-3">
        <div className="form-group form-group--card-holder col-md-12">
          <label className="label" htmlFor="card-holder">Name</label>
          <div id="card-holder"></div>
          <div id="card-holder-error" className="field-error" role="alert"></div>
        </div>
      </div>
      <div className="row mb-3">
        <div className="form-group form-group--card-number col-md-12">
          <label className="label" htmlFor="card-number">Card number</label>
          <div id="card-number"></div>
          <div id="card-number-error" className="field-error" role="alert"></div>
        </div>
      </div>
      <div className="row mb-3">
        <div className="col-md-6"> {/* Hier ist die Änderung */}
          <div className="form-group form-group--expiry-date">
            {/*<label className="label" htmlFor="expiry-date">Expiry date</label>*/}
            <div id="expiry-date"></div>
            <div id="expiry-date-error" className="field-error" role="alert"></div>
          </div>
        </div>
        <div className="col-md-6"> {/* Hier ist die Änderung */}
          <div className="form-group form-group--verification-code">
            <label className="label" htmlFor="verification-code">CVC</label>
            <div id="verification-code"></div>
            <div id="verification-code-error" className="field-error" role="alert"></div>
          </div>
        </div>
      </div>
    </div>
    <div id="form-error" className="field-error" role="alert"></div>
    {/*<button type="submit">Bezahlen</button>*/}
  </form>
</div>
  );
};

export default CreditCardForm;